/**
 * Downloads a Blob to a file on the client's machine.
 * @param blob - The Blob to be downloaded.
 * @param fileName - The name to be given to the downloaded file.
 */
export const downloadBlobToDisk = (blob: Blob, fileName: string) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const downloadFileToDisk = (jsonContent: string, fileName: string, fileType: string) => {
    const element = document.createElement('a');
    const file = new Blob([jsonContent], { type: fileType });
    const url = URL.createObjectURL(file);

    element.href = url;
    element.download = fileName;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
};
